<template lang="pug">
  vSelect.group-from-organization-select(:value="selectedOption" :options="options" label="name" @input="onInput" :placeholder="loading ? 'Loading...' : 'Select A Group'" :disabled="loading")
</template>

<script>
import vSelect from 'vue-select'
import Security from '@/service/apis/Security'

export default {
  props: {
    organizationId: {
      type: Number,
      required: false
    },
    value: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      options: [],
      selectedOption: null,
      loading: false
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      const req = {
        organizationId: this.organizationId,
        size: 1000,
        page: 0
      }

      Security.listGroupsFromOrganization(req)
        .then((resp) => {
          this.options = resp.data.content
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => { this.loading = false })
    },
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.selectedOption = val
      this.$emit('input', val ? val.id : null)
    },
    getSelectedGroup() {
      return this.selectedOption
    },
  },
  watch: {
    value() {
      this.updateSelectedOption()
    },
    organizationId() {
      if (this.organizationId) {
        this.fetchData()
      } else {
        this.selectedOption = null
        this.options = []
      }
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/GroupFromOrganizationSelect.vue